import { ChangeEvent, ChangeEventHandler, forwardRef, memo, useCallback } from "react";
import { InputContainer, InputContainerProps } from "../../index";

export type CardCVCFieldProps = Omit<InputContainerProps, "inputComponent" | "onChange" | "value"> & {
  onChange?: (value: string | null, e?: ChangeEvent<HTMLInputElement> | null) => void,
  value?: string | null
}

export const CardCVCField = memo(forwardRef<HTMLInputElement, CardCVCFieldProps>((
  {
    onChange,
    value,
    ...props
  }, ref) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const newValue = (e?.target?.value || "").replace(/\D/g, "")
      onChange?.(newValue, e)
    },
    [ onChange ]
  );

  return <InputContainer
    autoComplete="cc-csc"
    autoCorrect="off"
    spellCheck="false"
    inputMode="numeric"
    {...props}
    value={value || ""}
    ref={ref}
    type="text"
    onChange={wrappedOnChange}
  />;
}));